export interface SidebarStore {
  open: boolean
  userMenuOpen: boolean
}
export const sidebarStore: SidebarStore = {
  open: false,
  userMenuOpen: false,
}
